import { Typography } from 'antd';
import React from 'react';
import bannerImgLg from '../../../assets/hp-catalog-hz-lg.jpeg';
import bannerImgMd from '../../../assets/hp-catalog-hz-md.jpeg';
import bannerImgSm from '../../../assets/hp-catalog-vt-sm.jpeg';
import settings from '../../../settings';
import { useWindowDimensions } from '../../../shared/window-dimensions';

const { Text, Title, Paragraph } = Typography;

function CatalogBannerImage() {
  const dimensions = useWindowDimensions();
  let isMobile = true;
  if (dimensions?.width > 600) {
    isMobile = false;
  }
  return (
    <>
      {isMobile ? (
        <img className="banner-img" src={bannerImgSm} />
      ) : (
        <img
          className="banner-img"
          src={bannerImgLg}
          srcSet={`${bannerImgSm} 1000w,
        ${bannerImgMd} 2000w,
        ${bannerImgLg} 3000w`}
          sizes={`(max-width: ${settings.screenSizes.md600}px) 1000w,
        (max-width: ${settings.screenSizes.lg992}px) 2000w,
            3000w`}
        />
      )}
      <style jsx>{`
        .banner-img {
          width: 100%;
          margin-bottom: 32px;
          max-width: 3000px;
          margin-right: auto;
          margin-left: auto;
        }
      `}</style>
    </>
  );
}

export default CatalogBannerImage;
